import React, { useCallback } from "react";
import { ConnectButton as RainbowConnectButton } from "@rainbow-me/rainbowkit";
import { useSignMessage, useAccount } from "wagmi";

function generateNonce() {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < 16; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

function createSiweMessage({ domain, address, uri, nonce, chainId }) {
  const issuedAt = new Date().toISOString();
  return [
    `${domain} wants you to sign in with your Ethereum account:`,
    address,
    "",
    "Sign in to Lyre",
    "",
    `URI: ${uri}`,
    `Version: 1`,
    `Chain ID: ${chainId}`,
    `Nonce: ${nonce}`,
    `Issued At: ${issuedAt}`,
  ].join("\n");
}

function SiweConnectButton({ signedIn }) {
  const { address, isConnected } = useAccount();
  const { signMessageAsync } = useSignMessage();
  const isSignedIn = signedIn === "true";

  const handleSiweLogin = useCallback(async () => {
    if (!address) return;

    const message = createSiweMessage({
      domain: window.location.host,
      address,
      uri: window.location.origin,
      chainId: 1,
      nonce: generateNonce(),
    });

    try {
      const signature = await signMessageAsync({ message });

      const response = await fetch("/session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message, signature }),
      });

      if (response.ok) {
        window.location.reload();
      } else {
        const data = await response.json();
        console.error("SIWE verification failed:", data.error);
      }
    } catch (error) {
      console.error("Sign-in failed:", error);
    }
  }, [address, signMessageAsync]);

  return (
    <div className="flex items-center gap-3">
      <RainbowConnectButton
        showBalance={false}
        chainStatus={window.location.hostname === "localhost" ? "icon" : "none"}
      />
      {isConnected && !isSignedIn && (
        <button
          onClick={handleSiweLogin}
          className="px-4 py-2 bg-indigo-600 text-white rounded-lg text-sm font-medium hover:bg-indigo-700 transition-colors"
        >
          Sign In
        </button>
      )}
    </div>
  );
}

export default SiweConnectButton;
